/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Snapshot_History_Refresh_Aria_LabelInputs */



/**
* | output |
* | --- |
* | "Refresh commit list" |
*
* @param {Snapshot_History_Refresh_Aria_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const snapshot_history_refresh_aria_label = /** @type {((inputs?: Snapshot_History_Refresh_Aria_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Snapshot_History_Refresh_Aria_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Actualiser la liste des commits")
	if (locale === "de") return /** @type {LocalizedString} */ ("Commit-Liste aktualisieren")
	if (locale === "it") return /** @type {LocalizedString} */ ("Aggiorna l'elenco dei commit")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Обновить список коммитов")
	if (locale === "es") return /** @type {LocalizedString} */ ("Actualizar la lista de confirmaciones")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("刷新提交列表")
	if (locale === "ja") return /** @type {LocalizedString} */ ("コミットリストを更新")
	if (locale === "hi") return /** @type {LocalizedString} */ ("कमिट सूची को रीफ़्रेश करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Atualizar lista de commits")
	return /** @type {LocalizedString} */ ("Refresh commit list")
});